import { client } from "../../../Infrastructure/agent";

export const loginService = {
  current: () => client.get("/user"),
  login: ({ username, password }) =>
    client.post("/login/authenticate", { username, password }),
  register: (registerdata) =>
    client.post("/main/registeruser", { data: { ...registerdata } }),
};

